
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Thanetogoacab() {



    const cardData =
    {
        keyword: 'Thane to goa Cabs',
        heading: 'Skyline Cabs: Thane to goa Cabs',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Goa Cab Services for a perfect coastal getaway. Whether you’re planning to relax on the beautiful beaches, explore vibrant markets, or experience the nightlife, our well-maintained vehicles and professional drivers ensure a smooth and enjoyable journey. We provide door-to-door pickups, transparent pricing, flexible travel schedules, and 24/7 customer support to make your trip seamless. Book your Goa cab with Skyline Cabs today and enjoy a hassle-free ride to India’s favorite beach destination!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Baga Beach",
        "description": "One of the most popular beaches in Goa, Baga Beach is known for its vibrant nightlife, water sports, and golden sands. It’s a great place to relax during the day and enjoy beach parties and shacks at night."
    },
    {
        "title": "Fort Aguada",
        "description": "A 17th-century Portuguese fort, Fort Aguada offers panoramic views of the Arabian Sea. The fort also houses a lighthouse and is a popular historical site for those interested in Goa's colonial past."
    },
    {
        "title": "Basilica of Bom Jesus",
        "description": "A UNESCO World Heritage Site, this stunning baroque church in Old Goa is famous for housing the mortal remains of St. Francis Xavier. It’s one of the oldest churches in India, attracting both history buffs and religious visitors."
    },
    {
        "title": "Anjuna Beach",
        "description": "Known for its laid-back atmosphere, Anjuna Beach is a favorite among backpackers and party-goers. The beach features vibrant flea markets, beachside shacks, and picturesque views of the Arabian Sea."
    },
    {
        "title": "Dudhsagar Waterfalls",
        "description": "Located on the Goa-Karnataka border, Dudhsagar Waterfalls is one of the tallest and most majestic waterfalls in India. The falls are surrounded by lush greenery, making it an ideal spot for nature lovers and trekkers."
    },
    {
        "title": "Palolem Beach",
        "description": "A crescent-shaped beach in South Goa, Palolem is known for its calm waters, clean sand, and relaxed atmosphere. It’s perfect for kayaking, yoga, or just unwinding in a peaceful beach hut."
    },
    {
        "title": "Shri Mangueshi Temple",
        "description": "One of the largest and most prominent temples in Goa, Shri Mangueshi Temple is dedicated to Lord Shiva. The temple is known for its beautiful architecture and serene surroundings."
    },
    {
        "title": "Vasco da Gama",
        "description": "A historic town in Goa, Vasco da Gama is known for its colonial heritage, bustling markets, and scenic views. It’s also the location of the Dabolim Airport, making it a convenient base for exploring Goa."
    },
    {
        "title": "Chapora Fort",
        "description": "Famous for its appearance in the movie *Dil Chahta Hai*, Chapora Fort offers stunning views of Vagator Beach and the Arabian Sea. It’s a great spot for history enthusiasts and photography lovers."
    },
    {
        "title": "Calangute Beach",
        "description": "One of the most popular beaches in North Goa, Calangute Beach offers a vibrant atmosphere with numerous water sports, beach shacks, and a variety of shopping options. It’s ideal for both relaxation and adventure."
    }
],

"services": [
    {
      "name": "Thane to Goa Cab Service",
      "description": "Skyline Cabs offers a comfortable and reliable cab service from Thane to Goa. Enjoy a smooth and scenic journey to the beautiful beaches of Goa."
    },
    {
      "name": "Goa Cab from Thane",
      "description": "Book a cab from Thane to Goa with Skyline Cabs. We provide timely and safe rides with professional drivers for a relaxing trip."
    },
    {
      "name": "Thane to Goa One Way Taxi",
      "description": "Rent a one-way taxi from Thane to Goa with Skyline Cabs. Ideal for travelers seeking a one-way trip with comfort and convenience."
    },
    {
      "name": "Thane to Goa Taxi Fare",
      "description": "The taxi fare from Thane to Goa depends on the type of vehicle and other factors. Skyline Cabs offers competitive pricing to ensure value for money."
    },
    {
      "name": "Goa Trip Taxi from Thane",
      "description": "Plan your Goa trip with Skyline Cabs. Book a taxi for a smooth and enjoyable journey from Thane to Goa, making your travel hassle-free."
    },
    {
      "name": "Outstation Cab Booking Thane to Goa",
      "description": "Skyline Cabs offers reliable outstation cab bookings from Thane to Goa. Comfortable vehicles and experienced drivers for a memorable trip."
    },
    {
      "name": "Navi Mumbai to Goa Cab Service",
      "description": "Skyline Cabs provides convenient and comfortable cab services from Navi Mumbai to Goa. Travel in comfort with our experienced drivers."
    },
    {
      "name": "Navi Mumbai to Goa Cab",
      "description": "Book a cab from Navi Mumbai to Goa with Skyline Cabs. Safe, affordable, and timely service, ensuring a smooth trip to the beaches of Goa."
    },
    {
      "name": "Navi Mumbai Goa Taxi Service",
      "description": "Skyline Cabs offers reliable taxi services for your journey from Navi Mumbai to Goa. Enjoy a comfortable and stress-free ride with professional drivers."
    },
    {
      "name": "Navi Mumbai to Goa One Way Taxi",
      "description": "Book a one-way taxi from Navi Mumbai to Goa with Skyline Cabs. A hassle-free travel option for those looking for a direct, comfortable journey."
    },
    {
      "name": "Goa Trip Taxi from Navi Mumbai",
      "description": "Travel in comfort with Skyline Cabs' Goa trip taxi services from Navi Mumbai. We provide spacious vehicles and a relaxing ride."
    },
    {
      "name": "Outstation Cab Service Navi Mumbai to Goa",
      "description": "Skyline Cabs offers outstation cab services from Navi Mumbai to Goa. Enjoy a safe and comfortable journey with our reliable cabs and experienced drivers."
    }
  ],
  "tableData": [
    ["Thane to Goa Cab Service", "Goa Cab from Thane"],
    ["Thane to Goa One Way Taxi", "Thane to Goa Taxi Fare"],
    ["Goa Trip Taxi from Thane", "Outstation Cab Booking Thane to Goa"],
    ["Navi Mumbai to Goa Cab Service", "Navi Mumbai to Goa Cab"],
    ["Navi Mumbai Goa Taxi Service", "Navi Mumbai to Goa One Way Taxi"],
    ["Goa Trip Taxi from Navi Mumbai", "Outstation Cab Service Navi Mumbai to Goa"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Thane to Goa Cabs",
      "WhyChoosedescription": "Travel comfortably and conveniently from Thane to Goa with our reliable cab service. Whether you're heading for a beach vacation, family trip, or business visit, we ensure a smooth journey."
    },
    {
      "WhyChooseheading": "Comfortable and Long-Distance Ready Cabs",
      "WhyChoosedescription": "Our cabs are well-equipped for long journeys, offering spacious seating, great suspension, and a comfortable ride that makes the Thane to Goa road trip enjoyable."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer competitive, budget-friendly pricing for your Thane to Goa cab ride, with no hidden charges—just straightforward, transparent rates you can trust."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Drivers",
      "WhyChoosedescription": "Our professional drivers are experienced with long-distance routes, ensuring safe, punctual, and courteous service throughout your journey to Goa."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "Travel in comfort and safety with our thoroughly cleaned, sanitized, and well-maintained vehicles, ensuring a hygienic and pleasant ride for the long trip."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Whether you need a one-way trip, round trip, or a multi-day stay in Goa, we offer flexible packages tailored to your travel plans."
    },
    {
      "WhyChooseheading": "24/7 Customer Support and Easy Booking",
      "WhyChoosedescription": "Booking your Thane to Goa cab is easy through our online platform or over the phone. Our 24/7 customer support team ensures a quick and hassle-free booking experience."
    },
    {
      "WhyChooseheading": "Perfect for Vacation, Business, or Group Travel",
      "WhyChoosedescription": "Whether you're planning a family vacation, a business trip, or a group getaway, our cabs provide the comfort, reliability, and convenience you need for a memorable Thane to Goa journey."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Thane to Goa with Skyline Cabs?',
            answer:
                'Booking a cab from Thane to Goa is easy. You can book via our website, mobile app, or by calling customer support. Just enter your pickup location (Thane), destination (Goa), travel date, and preferred vehicle to confirm your booking.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Thane to Goa?',
            answer:
                'The distance from Thane to Goa is approximately 590 km. The travel time generally ranges from 9 to 11 hours, depending on road conditions and traffic. Our drivers are experienced in taking the best routes to ensure a comfortable and timely journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Thane to Goa trip?',
            answer:
                'We offer a range of vehicles for the Thane to Goa journey, including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups, we provide Tempo Travellers and luxury coaches for maximum comfort.',
        },
        {
            id: 4,
            question: 'Are your cab fares for Thane to Goa fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing for the Thane to Goa journey. The fare covers vehicle rental, driver charges, fuel, tolls, taxes, and any applicable service fees. You will know the total fare before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Thane to Goa?',
            answer:
                'Yes, we offer one-way cab options from Thane to Goa for your convenience. You can also opt for a round-trip if you plan to return to Thane at a later time.',
        },
        {
            id: 6,
            question: 'What is the best time to travel from Thane to Goa?',
            answer:
                'The best time to visit Goa is during the cooler months, from October to March. However, Skyline Cabs operates throughout the year, and our drivers are trained to manage all weather conditions for a safe and pleasant journey.',
        },
        {
            id: 7,
            question: 'Are stopovers allowed during the Thane to Goa journey?',
            answer:
                'Yes, we allow short stopovers along the way for refreshments, meals, or sightseeing. Just inform the driver if you’d like to take a break or explore any specific spots en route.',
        },
        {
            id: 8,
            question: 'What payment options are available for the Thane to Goa cab?',
            answer:
                'We accept a wide range of payment methods, including UPI, credit/debit cards, net banking, and cash payments after the trip. All online payments are processed securely through trusted payment gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Thane to Goa cab booking?',
            answer:
                'Yes, you can modify or cancel your booking easily via our website, mobile app, or by contacting our customer support team. We offer flexible cancellation policies to accommodate any changes to your plans.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for the Thane to Goa trip?',
            answer:
                'Skyline Cabs offers a comfortable, safe, and reliable journey from Thane to Goa. With well-maintained vehicles, experienced drivers, and transparent pricing, we ensure a seamless travel experience with exceptional customer service.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rahul Deshmukh",
            rating: 5,
            review: "Had a great trip from Thane to Goa with Skyline Cabs. The car was spacious and comfortable, and the driver was professional and friendly. The journey was smooth and enjoyable. Highly recommended!"
        },
        {
            name: "Miss. Priya Shah",
            rating: 4,
            review: "Booked a one-way cab from Thane to Goa. The vehicle was clean, and the drive was very smooth. The only issue was that the AC could have been cooler. Overall, great experience!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Thane to Goa Cabs",
  "image": "https://skylinecabs.com/assets/images/thane-to-goa-cab.jpg",
  "description": "Book Thane to Goa cabs online with Skyline Cabs for a scenic, safe, and comfortable ride. Choose from AC sedans, SUVs, or luxury cars for one-way or round trips with experienced drivers and 24/7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7647"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6499",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/thane-to-goa-cabs"
  }
};



      
    

    return (
        <div>

<Helmet>
  <title>Thane to Goa Cabs | One-Way & Round Trip Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Thane to Goa cabs online with Skyline Cabs for a scenic, safe, and comfortable ride. Choose from AC sedans, SUVs, or luxury cars for one-way or round trips with experienced drivers and 24/7 availability." 
  />
  <meta 
    name="keywords" 
    content="Thane to Goa Cabs, One Way Cab Thane to Goa, Round Trip Taxi Goa from Thane, Thane to Goa SUV Cab, Thane to Goa Sedan Taxi, Outstation Cab Thane to Goa, Luxury Car Hire Goa Trip, Skyline Cabs Goa Booking, AC Taxi from Thane to Goa, 24/7 Thane Goa Taxi Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/97.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Thanetogoacab;